/*
* @Author: yongwenhao
* @Date: 2020-04-07 10:35:22
* @describe: 服务中心
*/
<template>
    <div class='service'>
        <RouterView></RouterView>
    </div>
</template>

<script>

    export default {
        name: "index",
    }
</script>

<style lang='less' scoped>
    .service {
        display: flex;
        flex-direction: column;
    }
</style>